import Vue from 'vue'
import Router from 'vue-router'
import routes from './routes'
import authService from 'service/authService'
import eventService from 'service/eventService'

// use
Vue.use(Router)

// 实例化Router
var router = new Router({
  base: '/home/',
  mode: 'history',
  linkActiveClass: 'active',
  routes,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

// 全局路由跳转前钩子
router.beforeEach((to, from, next) => {
  eventService.$emit('router.beforeEach', to, from, next)
  // 登录检查
  if (to.matched.some(route => route.meta.requireAuth)) {
    if (!authService.isLoggedIn()) {
      // 登录
      return authService.login()
    }
  }
  if (to.matched.some(route => route.meta.requireAdmin)) {
    if (!authService.isAdmin()) {
      return router.push('/no-priv')
    }
  }

  next()
})

// 全局路由跳转后钩子
router.afterEach(route => {
  eventService.$emit('router.afterEach', route)
  // 百度PV统计
  var path = location.href.replace(location.origin, '')
  window._hmt.push(['_trackPageview', path])
  window._hmt.push(['_trackEvent', '页面', route.meta.title, 'path', path])
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js